import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Badge from '@material-ui/core/Badge'

import Window from 'components/dialog/Window'
import FormDialog from 'components/form/Dialog'

const useStyles = makeStyles(theme => ({
  root: {

  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  badge: {
    paddingLeft: theme.spacing(1),
    marginBottom: theme.spacing(2),
    flexGrow: 0,
  },
  buttonContainer: {
    flexGrow: 1,
    textAlign: 'right'
  },
  button: {
    padding: 2,
    marginBottom: theme.spacing(2),
  },
  
}))


const EditSlotDialog = ({
  slot,
  title = 'Edit',
  schema = [],
  data = {},
  error,
  open,
  onOpen,
  onClose,
  onUpdate,
  onReset,
}) => {
  const classes = useStyles()

  const [ resetting, setResetting ] = useState(false)
  const hasOverrides = Object.keys(slot._overriddenValues || {}).length > 0

  return (
    <div className={ classes.root }>

      <div className={ classes.toolbar }>
        <div className={ classes.badge }>
          <Badge
            color="secondary"
            variant="dot"
          >
          </Badge>&nbsp;&nbsp;= overidden
        </div>
        <div className={ classes.buttonContainer }>
          {
            hasOverrides && (
              <>
                <Button
                  className={ classes.button }
                  variant="outlined"
                  onClick={ () => setResetting(true) }
                >
                  Reset
                </Button>
                &nbsp;
              </>
            )
          }
          <Button
            className={ classes.button }
            color="secondary"
            variant="outlined"
            onClick={ onOpen }
          >
            { title }
          </Button>
        </div>
      </div>
      {
        open && (
          <FormDialog
            withCancel
            size="sm"
            schema={ schema }
            error={ error }
            initialValues={ data }
            onCancel={ onClose }
            onSubmit={ onUpdate }
          />
        )
      }
      {
        resetting && (
          <Window
            open
            title="Reset Overrides"
            size="sm"
            withCancel
            submitTitle="Confirm"
            onCancel={ () => setResetting(false) }
            onSubmit={ () => {
              setResetting(false)
              onReset()
            }}
          >
            Are you sure you want to reset the overridden values?
          </Window>
        )
      }
    </div>
  )
}

export default EditSlotDialog